<h5>{{ "Template.SupplierHeaderImageUploadComponent.subHeader_headerImage" | translate }}</h5>

<h6>{{ "Template.SupplierHeaderImageUploadComponent.subHeader_forBrandStore" | translate }}</h6>

<p>
  <small>{{ "Template.SupplierHeaderImageUploadComponent.text_explanation" | translate }}</small>
</p>

@if (loading) {
  <div class="p-5 text-center">
    <fa-icon icon="spinner" animation="spin" size="3x"></fa-icon>
  </div>
}

<div class="form-group">
  <input type="file" #filePicker class="form-control form-control-sm" id="image" accept="image/png,image/jpeg" (change)="onImagePicked($event)" />

  <div class="image-preview">
    @if (imageForm.controls.imageUrl.value) {
      <img class="img-fluid" [src]="imageForm.controls.imageUrl.value" />
    }
    @if (imageForm.controls.imageData.value) {
      <img class="img-fluid" [src]="imageForm.controls.imageData.value" />
    }
  </div>
</div>

@if (imageForm.controls.imageUrl.value || imageForm.controls.imageData.value) {
  <button (click)="removeImage()" class="btn btn-sm btn-outline-danger d-block w-100 mb-1" [disabled]="saving">
    {{ "Template.SupplierHeaderImageUploadComponent.btn_remove" | translate }}
    <fa-icon icon="trash" class="ms-1"></fa-icon>
  </button>
}

<button (click)="saveImage()" class="btn btn-sm btn-secondary d-block w-100" [disabled]="imageForm.controls.imageData.value == '' || saving">
  @if (saving) {
    <fa-icon icon="spinner" animation="spin" class="me-1"></fa-icon>
  }
  {{ "Template.SupplierHeaderImageUploadComponent.btn_save" | translate }}
  <fa-icon icon="check" class="ms-1"></fa-icon>
</button>
